import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {getAbp} from '../../../storage/sessionStorage';
import BasePage from './BasePage';
import { Row, Col, Form, Button} from 'react-bootstrap'
import DashBox from '../dashboard/DashBox';
import MessageBox from '../dashboard/MessageBox';
import LineChart from '../dashboard/LineChart';
import BarChart from '../dashboard/BarChart';

class HomePage extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            selectedEntity: 10
        };
      } 
  
      static defaultProps = {
      }
  
      componentDidMount(){
      }
  
      onItemSelectionChanged = (rowId) => {
  
      }
  
    //   showMenuCount(){
    //     if (!_.isEmpty(getAbp())){
    //         return(<span>Menu Access: {getAbp().MainMenu.items.map(x => {return <span key={x.name}>{x.name} </span>})}</span>)
    //     }
    //   }

    //   userInfo = () => {
    //       if (!_.isEmpty(this.props.auth.user)){
    //           return (
    //               <div>
    //                 <span>{this.props.auth.user.name} </span><br/>
    //                 <span>{this.props.auth.user.surname} </span><br/>
    //                 <span>{this.props.auth.user.userName} </span><br/>
    //                 <span>{this.props.auth.user.emailAddress} </span><br/>
    //                 {this.showMenuCount()}
    //               </div>
    //           );
    //       }
    //       else return null;
    //   }

      render(){
  
          return (
            <BasePage title="Home">
                <Row>
                    <Col className='col-lg-3'>
                        <MessageBox/>
                    </Col>
                    <Col className='col-lg-9'>
                        <Row>
                            <Col className='col-lg-12'>
                            <Form>
                                <Form.Group controlId="exampleForm.SelectCustom">
                                    {/* <Form.Label>Custom select</Form.Label> */}
                                    <Form.Control as="select" custom onChange={(e) => {this.setState({selectedEntity:e.target.value})}}>
                                        <option value='10'>SA</option>
                                        <option value='20'>SB</option>
                                        <option value='30'>KZN</option>
                                        <option value='40'>WC</option>
                                        <option value='5'>KE</option>
                                        <option value='6'>KB</option>
                                        <option value='7'>KP</option>
                                    </Form.Control>
                                </Form.Group>
                                </Form>
                            </Col>
                        </Row>
                        <Row className='p-0'>
                            <Col className='p-0'><DashBox colour='info' count={this.state.selectedEntity} countDetail='Templates to approve' icon='fa-file-alt'></DashBox></Col>
                            <Col className='p-0'><DashBox colour='warning' count={this.state.selectedEntity} countDetail='Invoices to approve' icon='fa-file-invoice-dollar'></DashBox></Col>
                            <Col className='p-0'><DashBox colour='danger' count={this.state.selectedEntity} countDetail='Postings in error' icon='fa-balance-scale-left'></DashBox></Col>
                            <Col className='p-0'><DashBox colour='secondary' count={this.state.selectedEntity} countDetail='Invoices in error' icon='fa-file-invoice-dollar'></DashBox></Col>
                        </Row>
                        {/* <Row className='p-0'>
                            <Col className='p-0'><DashBox colour='seacompurple' count={this.state.selectedEntity} countDetail='Credit Notes to Approve' icon='fa-file-alt'></DashBox></Col>
                            <Col className='p-0'><DashBox colour='seacomlavender' count={this.state.selectedEntity} countDetail='Invoices Approved Today' icon='fa-clock'></DashBox></Col>
                        </Row> */}
                        <Row className='p-0'>
                            <Col className='p-0'>
                                <LineChart/>
                            </Col>
                            <Col className='p-0'>
                                <BarChart/>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                {/* <Row>
                    <Col><DashBox colour='info' count='10' countDetail='Templates to approve' icon='fa-file-alt'></DashBox></Col>
                    <Col><DashBox colour='warning' count='10' countDetail='Invoices to approve' icon='fa-file-invoice-dollar'></DashBox></Col>
                    <Col><DashBox colour='danger' count='10' countDetail='Postings in error' icon='fa-balance-scale-left'></DashBox></Col>
                    <Col><DashBox colour='secondary' count='10' countDetail='Invoices in error' icon='fa-file-invoice-dollar'></DashBox></Col>
                </Row> */}
            </BasePage>
            );
      }
  
  }
  
  const mapStateToProps = (state) => {
      return{
          fetchingData: state.fetchingData === true,
          auth: state.auth,
      };
  }
  
  export default connect(
      // map state to props
      mapStateToProps, 
      // map dispatch to props
      (dispatch, ownProps) => ({
        
        })
      )(HomePage);